Object.assign(exports, require('./get-sign-event'))
